import styled from 'styled-components';
import media from '../../constants/media';

export const ContainerRoot = styled.div<{ isSideBySide: Boolean }>`
	display: ${({ isSideBySide }) => (isSideBySide ? 'grid' : 'block')};
	grid-template-columns: ${({ isSideBySide }) => (isSideBySide ? '1fr 1fr' : 'none')};

	${media.mobileAndTabletOnly`
		grid-template-columns: none;
	`};
`;
